import {Directive, Self} from '@angular/core';
import {LineChartComponent} from '@swimlane/ngx-charts';

// Purpose of this directive is to reduce the
@Directive({
  selector: 'ngx-charts-line-chart[fix-margin]'
})
export class MyNgxChartDirective {
  constructor(@Self() chart: LineChartComponent) {
    chart.margin = [10, 10, -25, 10];
  }
}
